const callOnLoadBeacon = (beaconUrl) => {
  if (!beaconUrl) return undefined;
  // eslint-disable-next-line no-undef
  navigator?.sendBeacon?.(beaconUrl);
};

export default callOnLoadBeacon;
